import { Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { PageContentExterneDto } from '../../../../services/dtos/page-content-externe.dto';
import { Form, Formik } from 'formik';
import InputForm from '../../../commun/input-form';
import Button from '@mui/material/Button';

/**
 * Renders a form for a title block.
 *
 * @param {object} props - The props required for rendering the form.
 * @param {PageContentExterneDto} props.fieldContent - The field content object.
 * @param {function} props.handleSubmit - The submit event handler function.
 * @param {object} props.iniValues - The initial values for the form fields.
 * @param {boolean} props.validate - Indicates whether to perform form validation or not.
 * @returns {JSX.Element} - The rendered form component.
 */
export default function TitleBlockForm(props: {
    fieldContent: PageContentExterneDto;
    handleSubmit: any;
    iniValues: any;
    validate: boolean;
}): JSX.Element {
    return (
        <Paper sx={{ padding: '20px' }}>
            <Formik initialValues={props.iniValues} onSubmit={props.handleSubmit}>
                <Form>
                    <Grid container>
                        <Grid item xs={12}>
                            <InputForm autoFocus id={'contenu'} name={'contenu'} type={'text'} />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Typography variant={'button'}>
                                <Button type="submit" variant="contained" disabled={props.validate}>
                                    Valider
                                </Button>
                            </Typography>
                        </Grid>
                    </Grid>
                </Form>
            </Formik>
        </Paper>
    );
}
